import * as React from 'react';

export const Search = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M7.222 0a7.222 7.222 0 0 1 5.766 11.573l2.72 2.72a1 1 0 0 1-1.32 1.497l-.095-.083-2.72-2.72A7.222 7.222 0 1 1 7.223 0zm0 2a5.222 5.222 0 1 0 3.63 8.977.482.482 0 0 1 .058-.067l.067-.059A5.222 5.222 0 0 0 7.222 2z"
    />
  </svg>
);
